import React from "react";
import Translations from "../../services/translation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import SorryBanner from "../../assets/img/SorryBanner.png";
import SpinnerTimeLoader from "../shared/timeLoading";
import EligibilityPhone from "./eligibiliy-phone.component";
import StorefrontTitle from "../shared/storefront-title.component";
import Settings from "../../services/settings.service";
const EligibilityFailedPhone = props => {
  let prefix = "3.3.2.B_";

  let mapStores = Settings?.footer?.get_map_stores;
  mapStores = mapStores.replace("%lang%", Translations.activeLang);

  let content = (
    <div className="stf-eligibility-cntnr eligibility-form-container eligibility-failed-stf">
      <img src={SorryBanner} alt="" />
      <StorefrontTitle
        title={Translations.keys[prefix + "failed_verification"]}
        desc={Translations.keys[prefix + "your_number_not_matched"]}
      />
      <EligibilityPhone
        phone={props.phone}
        phoneCode={props.phoneCode}
        countryDisabled={props.countryDisabled}
        updateContactField={props.updateContactField}
        handleCountryCode={props.handleCountryCode}
      />
      <button
        className={"common-button"}
        onClick={() => {
          FirebaseAnalytics.button_clicked(
            prefix + "btn_continue"
          );
          props.checkEligibilityRoot();
        }}
        disabled={!props.phone.valid}
      >
        {Translations.keys[prefix + "btn_continue"]}
      </button>
      <span>{Translations.keys[prefix + "or_you_can_visit"]}</span>
      <a className="common-a-button-light" href={mapStores}>{Translations.keys[prefix + "visit_store"]}</a>
    </div>

  );
  if (props.loading) {
    content = <SpinnerTimeLoader />
  }
  return content;
};
export default EligibilityFailedPhone;
